import { Controller } from "@hotwired/stimulus"

// Toggles the study group form between "pick a book" and "free-form topic" modes.
// When switching, clears the inactive field so we don't submit both.
export default class extends Controller {
  static targets = ["modeBtn", "bookField", "topicField"]
  static values = { mode: String }

  connect() {
    this.applyMode(this.modeValue || "book")
  }

  switchMode(event) {
    const mode = event.currentTarget.dataset.mode
    this.applyMode(mode)
  }

  applyMode(mode) {
    this.modeValue = mode
    const ACTIVE = ["bg-amber-100", "border-amber-300", "text-amber-900", "font-medium"]
    const INACTIVE = ["bg-white", "border-beige-200", "text-beige-600", "hover:bg-beige-50"]

    this.modeBtnTargets.forEach((btn) => {
      const isActive = btn.dataset.mode === mode
      ACTIVE.forEach((c) => btn.classList.toggle(c, isActive))
      INACTIVE.forEach((c) => btn.classList.toggle(c, !isActive))
    })

    if (mode === "book") {
      this.bookFieldTarget.classList.remove("hidden")
      this.topicFieldTarget.classList.add("hidden")
      this.clearField(this.topicFieldTarget)
    } else {
      this.topicFieldTarget.classList.remove("hidden")
      this.bookFieldTarget.classList.add("hidden")
      this.clearField(this.bookFieldTarget)
    }
  }

  clearField(container) {
    container.querySelectorAll("input, select, textarea").forEach((el) => {
      el.value = ""
    })
  }
}
